import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "./ui/command";
import { Check, ChevronsUpDown } from "lucide-react";

export default function CategoryPicker({ value, onChange, categories, allLabel, placeholder = "Choose a category", className = "", testid }) {
  const [open, setOpen] = useState(false);
  const pick = (v) => { onChange(v); setOpen(false); };
  const label = value === "all" ? allLabel : value || placeholder;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" role="combobox" aria-expanded={open} data-testid={testid}
          className={`flex h-10 w-full items-center justify-between rounded-md border border-input bg-white px-3 text-sm text-black ${className}`}>
          <span className={`truncate ${value ? "" : "text-zinc-500"}`}>{label}</span>
          <ChevronsUpDown className="w-4 h-4 opacity-50 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[var(--radix-popover-trigger-width)] min-w-[260px]" align="start">
        <Command filter={(v, s) => (v.toLowerCase().includes(s.toLowerCase().trim()) ? 1 : 0)}>
          <CommandInput placeholder="Type to search..." data-testid={testid && `${testid}-search`} />
          <CommandList className="max-h-72">
            <CommandEmpty>No matching business type.</CommandEmpty>
            {allLabel && <Item v="all" label={allLabel} value={value} pick={pick} />}
            {categories.map((c) => <Item key={c} v={c} label={c} value={value} pick={pick} />)}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}

function Item({ v, label, value, pick }) {
  return (
    <CommandItem value={label} onSelect={() => pick(v)} data-testid={`category-option-${v.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
      <Check className={`w-4 h-4 mr-2 ${value === v ? "opacity-100" : "opacity-0"}`} /> {label}
    </CommandItem>
  );
}
